import type {
  GuideChoice,
  GuideStage,
} from "../../../../../../../../../api/kehrblatt/learning-guide"

/** URL state describes reading position only; it never changes personal completion. */
export function readStageLocation(stages: GuideStage[], choices: GuideChoice[], search: string) {
  const params = new URLSearchParams(search)
  const requestedStage = params.get("etappe")
  const stageIndex = Math.max(
    0,
    stages.findIndex(
      (stage) => stage.key === requestedStage || stage.legacy_keys?.includes(requestedStage ?? ""),
    ),
  )
  const selected: Record<string, string> = {}
  for (const choice of choices) {
    const candidate = params.get(`weg-${choice.key}`)

    if (choice.options.some((option) => option.key === candidate)) selected[choice.key] = candidate!
  }

  return { stageIndex, selected }
}

export function stageLocation(
  path: string,
  search: string,
  stageKey: string,
  choice?: { key: string; option: string },
): string {
  const params = new URLSearchParams(search)
  params.set("etappe", stageKey)

  if (choice) params.set(`weg-${choice.key}`, choice.option)

  return `${path}?${params.toString()}`
}
